import { render } from "./Webcam.vue?vue&type=template&id=f506df9a"
import script from "./Webcam.vue?vue&type=script&lang=js"
export * from "./Webcam.vue?vue&type=script&lang=js"

import "./Webcam.vue?vue&type=style&index=0&id=f506df9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__